
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M2.5 6c0 .83.67 1.5 1.5 1.5h3.5V18c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V7.5H14c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H4c-.83 0-1.5.67-1.5 1.5zM20 9.5h-6c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h1.5V18c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.5H20c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z"}})])
          )
        }
      }
    